module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_brand2_m_en.a81b3ecdd2a4c8e0da15b50c8495b4e5.png";